import { cva } from 'class-variance-authority';
import { abmContainer } from '../abm-shared.style';

/** Overlaid on the page banner and transparent, as on abmparking.com. */
export const headerBar = 'tw:absolute tw:inset-x-0 tw:top-0 tw:z-30 tw:w-full tw:text-white';

/** 54px tall on phones (menu button left, logo centred), 70px from 800px (logo left, menu right). */
export const headerInner = `${abmContainer} tw:relative tw:flex tw:h-[3.375rem] tw:items-center tw:min-[50rem]:h-[4.375rem]`;

export const logoLink =
  'tw:absolute tw:left-1/2 tw:-translate-x-1/2 tw:min-[50rem]:static tw:min-[50rem]:translate-x-0';

/** 82x32 on phones, 102x40 from 800px. */
export const logoImage = 'tw:h-8 tw:w-auto tw:min-[50rem]:h-10';

export const desktopNav = 'tw:ml-auto tw:hidden tw:h-full tw:items-stretch tw:min-[50rem]:flex';

/** Top-level item: full header height, 16px side padding, navy wash on hover. */
export const navLink =
  'tw:flex tw:h-full tw:items-center tw:whitespace-nowrap tw:px-base tw:text-16 tw:font-medium tw:text-white tw:no-underline tw:transition-colors tw:hover:bg-abm-navy/[0.67]';

export const groupWrapper = 'tw:group tw:relative tw:flex tw:h-full';

/** Sub-menu: opens on hover and while anything inside the group has keyboard focus. */
export const dropdownPanel =
  'tw:absolute tw:left-0 tw:top-full tw:z-40 tw:hidden tw:w-[11.25rem] tw:flex-col tw:bg-abm-navy/[0.67] tw:backdrop-blur-[4px] tw:group-hover:flex tw:group-focus-within:flex';

export const dropdownLink =
  'tw:block tw:px-base tw:py-micro tw:text-[0.8125rem] tw:leading-[1.3] tw:text-white tw:no-underline tw:transition-colors tw:hover:bg-abm-blue';

export const menuToggle = 'tw:min-h-0 tw:p-nano tw:text-white tw:min-[50rem]:hidden';

export const mobilePanel = cva(
  'tw:border-t tw:border-white/20 tw:bg-abm-navy tw:min-[50rem]:hidden',
  {
    variants: {
      open: { true: 'tw:block', false: 'tw:hidden' },
    },
    defaultVariants: { open: false },
  }
);

export const mobileList = `${abmContainer} tw:flex tw:flex-col tw:gap-nano tw:py-small`;

export const mobileLink =
  'tw:block tw:py-micro tw:text-16 tw:font-medium tw:text-white tw:no-underline';

export const mobileGroup = 'tw:flex tw:flex-col';

export const mobileGroupLabel =
  'tw:pt-small tw:text-12 tw:font-semibold tw:uppercase tw:tracking-wide tw:text-white/70';

export const mobileSubLink =
  'tw:block tw:py-nano tw:pl-small tw:text-14 tw:text-white tw:no-underline';

export const mobileViewAll = 'tw:font-semibold';
